import { render, staticRenderFns } from "./CompanySelection.vue?vue&type=template&id=2cbb234d&"
import script from "./CompanySelection.vue?vue&type=script&lang=js&"
export * from "./CompanySelection.vue?vue&type=script&lang=js&"
import style0 from "./CompanySelection.vue?vue&type=style&index=0&id=2cbb234d&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports